import React from 'react';
    import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
    import HomePage from './pages/HomePage';
    import AboutPage from './pages/AboutPage';
    import CoachingPage from './pages/CoachingPage';
    import ContactPage from './pages/ContactPage';
    import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
    import TermsOfServicePage from './pages/TermsOfServicePage';

    function App() {
      return (
        <Router>
          <div className="min-h-screen bg-white">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/services" element={<CoachingPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="/terms-of-service" element={<TermsOfServicePage />} />
            </Routes>
          </div>
        </Router>
      );
    }

    export default App;